module.exports = __webpack_public_path__ + "a3ffda2041cc51b1c652adeffafe23a5.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/es.json
// module id = 1150
// module chunks = 0